// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/lifeline/line-point.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeLine{
    position: relative;
    width: 44px;
    background-size: 17px;
    background-position: left top;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: repeat-y; 
    flex-shrink: 0;
}

.timeLine_point{
    position: absolute;
    font-style: italic;
    font-weight: 400;
    font-size: 9px;
    line-height: 12px;
    text-align: center;
    color: #000000;

    background: #FFFFFF;
    border: 1px solid #E4E4E9;
    box-shadow: 0px 4.7542px 13.4702px -3.96183px rgba(58, 77, 233, 0.15);
    border-radius: 24px;
    padding: 2px 5px;
    
}

.timeLine_point--unselected{
    display: none;
}

.timeLine_point--selected{

}
`, "",{"version":3,"sources":["webpack://./src/components/timeLine/TimeLine.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,6BAA6B;IAC7B,yDAA6D;IAC7D,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;;IAEd,mBAAmB;IACnB,yBAAyB;IACzB,qEAAqE;IACrE,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;AAEA","sourcesContent":[".timeLine{\n    position: relative;\n    width: 44px;\n    background-size: 17px;\n    background-position: left top;\n    background-image: url('../../assets/lifeline/line-point.svg');\n    background-repeat: repeat-y; \n    flex-shrink: 0;\n}\n\n.timeLine_point{\n    position: absolute;\n    font-style: italic;\n    font-weight: 400;\n    font-size: 9px;\n    line-height: 12px;\n    text-align: center;\n    color: #000000;\n\n    background: #FFFFFF;\n    border: 1px solid #E4E4E9;\n    box-shadow: 0px 4.7542px 13.4702px -3.96183px rgba(58, 77, 233, 0.15);\n    border-radius: 24px;\n    padding: 2px 5px;\n    \n}\n\n.timeLine_point--unselected{\n    display: none;\n}\n\n.timeLine_point--selected{\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
